import type { Placement } from '@floating-ui/react';
import React from 'react';
import { zIndexVoxel } from '../../../logic/zIndexVoxel';
import { Tooltip, TooltipContent, TooltipTrigger } from './TooltipLogic';

export interface VoxelTooltipLongProps {
  message?: string | React.ReactNode;
  placement?: Placement;
  closeOnClick?: boolean;
  disabled?: boolean;
}

export const VoxelTooltipLong: React.FC<VoxelTooltipLongProps> = ({
  children,
  message,
  placement = 'top-start',
  closeOnClick,
  disabled,
}) => {
  if (!message) return <>{children}</>;
  // Legacy handling of disabled
  // This should be phased out and we should instead visually disable elements and prevent onClick/onChange etc
  // in the code when disabled. This is to keep all the mouse events firing so that the tooltip still works despite it being disabled
  if (disabled) return <>{children}</>;
  return (
    <Tooltip placement={placement}>
      <TooltipTrigger asChild={!!children} closeOnClick={closeOnClick}>
        {children}
      </TooltipTrigger>
      <TooltipContent
        className={`${zIndexVoxel.tooltip} 
        ring-1 ring-gray-200 shadow-md bg-white rounded-md
        px-4 py-4
        max-w-[288px] !text-[13px]
        `}>
        {message}
      </TooltipContent>
    </Tooltip>
  );
};

export default VoxelTooltipLong;
